{
  "filters": {
    "state": "Estado",
    "any": "Cualquiera",
    "approved": "Aprobado",
    "rejected": "Rechazado",
    "awaitingReview": "En espera de revisión",
    "organization": "Organización",
    "clientName": "Nombre del cliente",
    "requestedDate": "Fecha solicitada",
    "approvedDate": "Fecha aprobada",
    "daysWaiting": "Días de espera",
    "document": "Documento",
    "name": "Nombre",
    "source": "Fuente",
    "sourceOptions": {
      "USER": "Usuario",
      "FLINKS": "Flinks"
    },
    "failReason": "Motivo del fallo",
    "transitNumber": "Número de tránsito",
    "institutionNumber": "Número de institución",
    "bankAccountNumber": "Número de cuenta bancaria",
    "actions": "Acciones",
    "stateOptions": {
      "AWAITING_REVIEW": "En espera de revisión",
      "APPROVED": "Aprobado",
      "REJECTED": "Rechazado",
      "ARCHIVED": "Archivado"
    }
  },
  "noFile": "¡Ningún documento cargado!",
  "bankAccountTransitions": {
    "approve": "Aprobar",
    "reject": "Rechazar"
  },
  "moderateBankAccount": "¿Está seguro?",
  "confirmationDialogTitle": "¿Está seguro de que desea {{transition}} esta cuenta bancaria?",
  "bankAccountPostfix": "Cuenta bancaria de",
  "bankAccountTitle": "Cuenta bancaria de {{name}}",
  "bankAccountTitleFallback": "Cuenta bancaria"
}
